import { getReference } from '@atc/bonnet-reference';
import { getSyndicatedMakesFromState, removeMakeModels, filterOutExcludedMakes } from '../utilities';
import { cloneDeep } from '../utilities/common';

export default function getMakeList(state) {

    return async (ctx) => {
        const makeListCondition = ctx.data && ctx.data.brand; // get makelist from researchable api for both KBB and Autotrader
        if (makeListCondition) {
            const { payload: makeCodes } = await getReference('makeCode');
            const makes = cloneDeep(makeCodes);
            ctx.data.makeCodes = removeMakeModels(makes);

            const makeList = await getSyndicatedMakesFromState(state);
            ctx.data.makeList = await filterOutExcludedMakes(false, makeList);

            if (ctx.query && ctx.query.makeCode) {
                if (makeCodes.length > 0) {
                    const matchingMake = makeCodes.find((make) => make.code?.toLowerCase() === ctx.query.makeCode?.toLowerCase());
                    ctx.query.make = matchingMake?.name || '';
                }
            }
        }
    };
}
